const PARK_GORKOGO_EVENT_PARAM = "parkgorkogoevent";

export const setParkGorkogoEventRegistrationParam = () => {
	if (typeof window === "undefined") {
		return;
	}

	localStorage.setItem("registration_params", PARK_GORKOGO_EVENT_PARAM);
};
